import { TranslationResponse } from './translation-response.interface';

export interface SettingsTranslationResponse {
    currencies: TranslationResponse[];
}
